import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import AlertRepository from "src/repository/AlertRepository";
import { __remove, __set } from "../../axios_indicator";
import Constants from "src/support/Constants";

export const getAlertListingByType = createAsyncThunk('alert_getAlertListingByType', async (params) => {
    params.notificationType === Constants.alertTypes.PCN ? __set('ALERT_API_CALL') : __set('EOL_ALERT_API_CALL');
    let res = await new AlertRepository().getAlertListingByType(params)
    let result = {}
    result.data = res.data;
    result.type = params.notificationType;
    params.notificationType === Constants.alertTypes.PCN ? __remove('ALERT_API_CALL') : __remove('EOL_ALERT_API_CALL');
    return result
});
export const getStockAlertListing = createAsyncThunk('alert_getStockAlertListingByType', async (params) => {
    __set('STOCK_ALERT_API_CALL');
    let res = await new AlertRepository().getStockAlertListing(params)
    let result = {}
    result.data = res.data;
    result.type = params.notificationType;
    __remove('STOCK_ALERT_API_CALL');
    return result
});

export const getAlertCount = createAsyncThunk('alert_getAlertCountByType', async (params) => {
    let res = await new AlertRepository().getAlertCount(params)
    let result = {}
    result.data = res;
    return result
});

const initialState = {
    PCNAlertListingByType: {},
    EOLAlertListingByType: {},
    StockAlertListingByType: {},
    alertTabsCount: {
        PCNCount: 0,
        EOLCount: 0,
        StockCount: 0,
    },
};
const slice = createSlice({
    name: "Alert",
    initialState: initialState,
    reducers: {
        setAlertTabCount: {
            reducer: (state, action) => {
                state.alertTabsCount = { ...state.alertTabsCount, ...action.payload };
                return state;
            }
        }
    },
    extraReducers: {
        [getAlertListingByType.fulfilled]: (state, { payload }) => {
            if (payload.type === Constants.alertTypes.PCN) {
                state.PCNAlertListingByType = payload.data;
                state.alertTabsCount = { ...state.alertTabsCount, PCNCount: payload.data.totalAlertList }
            } else if (payload.type === Constants.alertTypes.EOL) {
                state.EOLAlertListingByType = payload.data;
                state.alertTabsCount = { ...state.alertTabsCount, EOLCount: payload.data.totalAlertList }
            }
            payload?.type === Constants.alertTypes.PCN ? __remove('ALERT_API_CALL') : __remove('EOL_ALERT_API_CALL');
            return state;
        },
        [getAlertListingByType.rejected]: (state, { payload }) => {
            payload?.type === Constants.alertTypes.PCN ? __remove('ALERT_API_CALL') : __remove('EOL_ALERT_API_CALL');
        },
        [getAlertCount.fulfilled]: (state, { payload }) => {
            state.alertTabsCount = { ...state.alertTabsCount, ...payload.data };
        },
        [getStockAlertListing.fulfilled]: (state, { payload }) => {
            state.StockAlertListingByType = payload.data
            state.alertTabsCount = { ...state.alertTabsCount, StockCount: payload.data.totalCount }
            __remove('STOCK_ALERT_API_CALL');
            return state;
        },
        [getStockAlertListing.rejected]: (state, { payload }) => {
            __remove('STOCK_ALERT_API_CALL');
        },
    },
});

export let { setAlertTabCount } = slice.actions;

export default slice.reducer;
